import { cn } from '../cn.js';

/**
 * Sized by the caller so the placeholder matches the real content's footprint. A skeleton of the
 * wrong size causes layout shift the moment data arrives, which is worse than a plain spinner.
 */
export function Skeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-bg-subtle', className)}
      aria-hidden="true"
      data-testid="skeleton"
    />
  );
}
